export const BASE_URL = "https://devoluzion.com";

export const SERVICES = [
  { id: "paginas-web", silo: "create", priority: true, wa: "web", es: { slug: "paginas-web", menu: "Sitios Web Premium" }, en: { slug: "websites", menu: "Premium Websites" } },
  { id: "desarrollo-web", silo: "create", priority: true, wa: "web", es: { slug: "desarrollo-web", menu: "Desarrollo Web" }, en: { slug: "web-development", menu: "Web Development" } },
  { id: "diseno-web", silo: "create", wa: "web", es: { slug: "diseno-web", menu: "Diseño Web" }, en: { slug: "web-design", menu: "Web Design" } },
  { id: "experiencias-web-3d", silo: "create", wa: "web", es: { slug: "experiencias-web-3d", menu: "Experiencias Web 3D" }, en: { slug: "3d-web-experiences", menu: "3D Web Experiences" } },
  { id: "ux-ui", silo: "create", wa: "web", es: { slug: "ux-ui", menu: "UX/UI" }, en: { slug: "ux-ui", menu: "UX/UI" } },
  { id: "landing-pages", silo: "create", wa: "web", es: { slug: "landing-pages", menu: "Landing Pages" }, en: { slug: "landing-pages", menu: "Landing Pages" } },
  { id: "seo", silo: "create", wa: "growth", es: { slug: "seo", menu: "SEO" }, en: { slug: "seo", menu: "SEO" } },
  { id: "desarrollo-software", silo: "build", priority: true, wa: "software", es: { slug: "desarrollo-software", menu: "Desarrollo de Software" }, en: { slug: "software-development", menu: "Software Development" } },
  { id: "software-a-medida", silo: "build", wa: "software", es: { slug: "software-a-medida", menu: "Software a Medida" }, en: { slug: "custom-software", menu: "Custom Software" } },
  { id: "desarrollo-apps", silo: "build", wa: "software", es: { slug: "desarrollo-apps", menu: "Desarrollo de Apps" }, en: { slug: "app-development", menu: "App Development" } },
  { id: "plataformas-saas", silo: "build", wa: "software", es: { slug: "plataformas-saas", menu: "Plataformas SaaS" }, en: { slug: "saas-development", menu: "SaaS Platforms" } },
  { id: "ecommerce", silo: "commerce", priority: true, wa: "ecommerce", es: { slug: "ecommerce", menu: "Ecommerce" }, en: { slug: "ecommerce-development", menu: "Ecommerce Development" } },
  { id: "shopify", silo: "commerce", wa: "ecommerce", es: { slug: "shopify", menu: "Shopify" }, en: { slug: "shopify-development", menu: "Shopify" } },
  { id: "woocommerce", silo: "commerce", wa: "ecommerce", es: { slug: "woocommerce", menu: "WooCommerce" }, en: { slug: "woocommerce-development", menu: "WooCommerce" } },
  { id: "automatizacion", silo: "automate", priority: true, wa: "automation", es: { slug: "automatizacion", menu: "Automatización de Procesos" }, en: { slug: "business-automation", menu: "Business Automation" } },
  { id: "automatizacion-whatsapp", silo: "automate", wa: "automation", es: { slug: "automatizacion-whatsapp", menu: "Automatización WhatsApp" }, en: { slug: "whatsapp-automation", menu: "WhatsApp Automation" } },
  { id: "agentes-ia", silo: "intelligence", priority: true, wa: "ai", es: { slug: "agentes-ia", menu: "Agentes de IA" }, en: { slug: "ai-agents", menu: "AI Agents" } },
  { id: "ia-para-empresas", silo: "intelligence", wa: "ai", es: { slug: "ia-para-empresas", menu: "IA para Empresas" }, en: { slug: "ai-for-business", menu: "AI for Business" } },
  { id: "chatbots-ia", silo: "intelligence", wa: "ai", es: { slug: "chatbots-ia", menu: "Chatbots IA" }, en: { slug: "ai-chatbots", menu: "AI Chatbots" } },
  { id: "agentes-comerciales-ia", silo: "intelligence", wa: "ai", es: { slug: "agentes-comerciales-ia", menu: "Agentes Comerciales IA" }, en: { slug: "ai-sales-agents", menu: "AI Sales Agents" } },
  { id: "marketing-digital", silo: "grow", wa: "growth", es: { slug: "marketing-digital", menu: "Marketing Digital" }, en: { slug: "digital-marketing", menu: "Digital Marketing" } },
  { id: "agencia-marketing", silo: "grow", priority: true, wa: "growth", es: { slug: "agencia-marketing", menu: "Agencia de Marketing Digital" }, en: { slug: "digital-marketing-agency", menu: "Digital Marketing Agency" } },
  { id: "google-ads", silo: "grow", wa: "growth", es: { slug: "google-ads", menu: "Google Ads" }, en: { slug: "google-ads", menu: "Google Ads" } },
  { id: "meta-ads", silo: "grow", wa: "growth", es: { slug: "meta-ads", menu: "Meta Ads" }, en: { slug: "meta-ads", menu: "Meta Ads" } },
  { id: "growth-marketing", silo: "grow", wa: "growth", es: { slug: "growth-marketing", menu: "Growth Marketing" }, en: { slug: "growth-marketing", menu: "Growth Marketing" } },
  { id: "analytics", silo: "grow", wa: "growth", es: { slug: "analytics", menu: "Analytics" }, en: { slug: "analytics", menu: "Analytics" } },
];

export const SILOS = [
  {
    id: "create",
    es: { name: "CREATE", desc: "Sitios y experiencias web que convierten visitas en intención." },
    en: { name: "CREATE", desc: "Websites and web experiences that turn visits into intent." },
    extras: [],
  },
  {
    id: "build",
    es: { name: "BUILD", desc: "Software, apps y plataformas que eliminan cuellos operativos." },
    en: { name: "BUILD", desc: "Software, apps and platforms that remove operational bottlenecks." },
    extras: [
      { es: "Sistemas Empresariales", en: "Business Systems", to: "desarrollo-software" },
      { es: "Portales de Clientes", en: "Customer Portals", to: "desarrollo-software" },
      { es: "Integraciones API", en: "API Integrations", to: "desarrollo-software" },
    ],
  },
  {
    id: "commerce",
    es: { name: "COMMERCE", desc: "Tiendas pensadas para vender, no solo para mostrar." },
    en: { name: "COMMERCE", desc: "Stores built to sell, not just to display." },
    extras: [
      { es: "Tiendas Online", en: "Online Stores", to: "ecommerce" },
      { es: "Ecommerce Personalizado", en: "Custom Ecommerce", to: "ecommerce" },
      { es: "Optimización de Conversión", en: "Conversion Optimization", to: "ecommerce" },
    ],
  },
  {
    id: "automate",
    es: { name: "AUTOMATE", desc: "Tu negocio operando aunque tú no estés." },
    en: { name: "AUTOMATE", desc: "Your business running even when you're not." },
    extras: [
      { es: "Automatización Comercial", en: "Sales Automation", to: "automatizacion" },
      { es: "CRM Automation", en: "CRM Automation", to: "automatizacion" },
      { es: "Integraciones", en: "System Integrations", to: "automatizacion" },
      { es: "Workflows", en: "Workflows", to: "automatizacion" },
    ],
  },
  {
    id: "intelligence",
    es: { name: "INTELLIGENCE", desc: "IA aplicada donde genera impacto medible." },
    en: { name: "INTELLIGENCE", desc: "AI applied where it creates measurable impact." },
    extras: [
      { es: "Asistentes Empresariales", en: "Business AI Assistants", to: "ia-para-empresas" },
      { es: "Automatización con IA", en: "AI Automation", to: "agentes-ia" },
    ],
  },
  {
    id: "grow",
    es: { name: "GROW", desc: "Adquisición y optimización continua basada en datos." },
    en: { name: "GROW", desc: "Continuous, data-driven acquisition and optimization." },
    extras: [
      { es: "SEO", en: "SEO", to: "seo" },
      { es: "CRO", en: "CRO", to: "growth-marketing" },
      { es: "Lead Generation", en: "Lead Generation", to: "growth-marketing" },
    ],
  },
];

export const STATIC_PAGES = [
  { id: "servicios", es: "servicios", en: "services" },
  { id: "precios", es: "precios", en: "pricing" },
  { id: "recursos", es: "recursos", en: "insights" },
  { id: "nosotros", es: "nosotros", en: "about" },
  { id: "contacto", es: "contacto", en: "contact" },
];

export function pathFor(lang, serviceId) {
  const s = SERVICES.find((x) => x.id === serviceId);
  return `/${lang}/${s[lang].slug}`;
}

export function staticPath(lang, pageId) {
  const p = STATIC_PAGES.find((x) => x.id === pageId);
  return `/${lang}/${p[lang]}`;
}

export function serviceBySlug(lang, slug) {
  return SERVICES.find((x) => x[lang].slug === slug);
}

export function staticPageBySlug(lang, slug) {
  return STATIC_PAGES.find((x) => x[lang] === slug);
}

// Maps any path to its equivalent in the target language (hreflang + lang switcher)
export function equivalentPath(pathname, targetLang, articlePairs = []) {
  const parts = pathname.split("/").filter(Boolean);
  const lang = parts[0] === "en" ? "en" : "es";
  const rest = parts.slice(1);
  if (rest.length === 0) return `/${targetLang}/`;

  const svc = serviceBySlug(lang, rest[0]);
  if (svc) return `/${targetLang}/${svc[targetLang].slug}`;

  const st = staticPageBySlug(lang, rest[0]);
  if (st) {
    if ((st.id === "recursos") && rest[1]) {
      const pair = articlePairs.find((a) => a[lang].slug === rest[1]);
      if (pair) return `/${targetLang}/${st[targetLang]}/${pair[targetLang].slug}`;
    }
    return `/${targetLang}/${st[targetLang]}`;
  }
  return `/${targetLang}/`;
}

export function allServicePaths() {
  return SERVICES.flatMap((s) => [
    { lang: "es", path: `/es/${s.es.slug}` },
    { lang: "en", path: `/en/${s.en.slug}` },
  ]);
}
